import { z } from 'zod/v4';

export const appEnvSchema = z.enum(['prod', 'prod-us', 'staging', 'local', 'preview']);

export type APP_ENV = z.infer<typeof appEnvSchema>;
